/**
 * AssetEntrancePointService
 * Service for AssetEntrancePoint lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetEntrancePoint CRUD operations */
export class AssetEntrancePointService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetEntrancePointService.DEFAULT_SERVICE_PATH,
            basePath: AssetEntrancePointService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetEntrancePointService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetEntrancePointService.BASE_PATH = 'api/asset-entrance-points';
//# sourceMappingURL=AssetEntrancePointService.js.map